module.exports = __webpack_public_path__ + "img/vertical_4_5_8003.73d6a835.png";